import React from "react";
import {
  FormDataConsumer,
  ReferenceInput,
  SelectInput,
  useTranslate,
} from "react-admin";
import moment from "moment";

const optionRenderer = (option, translate) => {
  if (option.id <= 0) {
    return translate(option.name);
  }
  return (
    <>
      {option.name} {option.start_at && "("}
      {option.start_at !== null &&
        moment(option.start_at).format(translate("app.date_format.short"))}
      {option.end_at !== null && " - "}
      {option.end_at !== null &&
        moment(option.end_at).format(translate("app.date_format.short"))}
      {option.start_at !== null && ")"}
    </>
  );
};

const LandingInput = (props) => {
  const translate = useTranslate();
  return (
    <FormDataConsumer {...props}>
      {({ formData, ...rest }) => (
        <ReferenceInput
          {...props}
          reference="bookmaker-landings"
          filter={{
            bookmaker_id: formData.bookmaker_id || 0,
            _id: formData.id || "not_expired",
          }}
        >
          <SelectInput
            optionText={(option) => optionRenderer(option, translate)}
          />
        </ReferenceInput>
      )}
    </FormDataConsumer>
  );
};
export default LandingInput;
